export default "__VITE_ASSET__mvBI5YyO__"